<template>
    <div
        class="action-dropdown"
        :class="props.class"
        ref="container"
        data-testid="dropdown-container"
    >
        <button
            @click="toggleDropdown"
            class="al2-button"
            ref="dropdownButton"
            data-testid="dropdown-button"
        >
            {{ text }}
            <al-icon :icon="icon" />
        </button>
        <div
            class="action-dropdown-content"
            :class="{ open: open }"
            :style="contentStyles"
            data-testid="dropdown-content-container"
        >
            <slot
                :close-dropdown="toggleDropdown"
                data-testid="dropdown-content"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import {
    defineProps, ref, computed,
    onMounted,
    onBeforeUnmount
} from 'vue';
const OPTION_MIN_WIDTH = 230; // px

interface Props {
    text?: string;
    icon?: string;
    class?: string;
}

const props = defineProps<Props>();
const container = ref<HTMLDivElement | null>(null);
const dropdownButton = ref<HTMLButtonElement | null>(null);
const open = ref<boolean>(false);
const icon = computed(() => props.icon ? props.icon : open.value ? 'chevron-up' : 'chevron-down');

const toggleDropdown = () => {
    open.value = !open.value;
};

const handleClickOutside = (event: Event) => {
    if (dropdownButton.value && !dropdownButton.value.contains(event.target as HTMLElement)) {
        open.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
});

const contentStyles = computed(() => {
    if (dropdownButton.value && container.value) {
        const buttonRect = dropdownButton.value.getBoundingClientRect();
        const containerRect = container.value.parentElement?.getBoundingClientRect();
        if (containerRect && buttonRect.left + OPTION_MIN_WIDTH >= containerRect.right) {
            return { right: 0 };
        }
    }
    return {};
});

</script>
<style lang="scss">
@import './style.scss';
</style>